var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activation-component-container"},_vm._l((_vm.activators),function(activator){return _c('div',{key:activator.id,staticClass:"activator"},[_c(activator.activatorType,{tag:"component",attrs:{"activator":activator,"mastery":_vm.mastery}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }